import { Box, Cell, Collapse, Container, SimpleGrid, Stack } from "@xcorejs/ui";
import { useContentSingletons, usePageContent, useXcoreUtils } from "@robe/client";
import { GoboValues, Product, ProductDetailPage } from "xcore/types";
import Focus from "design-system/robe/Focus";
import RobeProductDetailHeading from "design-system/robe/RobeProductDetailHeading";
import { useState, useEffect, Fragment } from "react";
import { resolveSrcSet } from "utils";
import { useGallery } from "../data";
import { WheelSet } from "./WheelSet";

const ProductGobos = () => {
  const { stringify, image } = useXcoreUtils();
  const product = usePageContent<Product>();
  const [detailPage] = useContentSingletons<[ProductDetailPage]>();
  const [showGobos, setShowGobos] = useState(false);
  const [[activeSet, activeWheel], setActive] = useState<[number, number]>(() => [0, 0]);

  const active = product?.values?.wheels?.[activeSet].wheels?.[activeWheel];
  const imgUrl = active?.values?.image ? image(active.values.image, { width: 300, height: 300 }) : null;
  const retinaImgUrl = active?.values?.image ? image(active.values.image, { width: 300, height: 300, enlargement: 2 }) : null;

  const [openLightbox] = useGallery({
    images: active ? [image(active.values!.image!, { width: 300, height: 300 })!] : [],
    white: true,
  });

  useEffect(() => setShowGobos(window.innerWidth >= 1024), []);
  return (
    <Box id={"#" + stringify(detailPage.values.anchorGobos)}>
      <Box id={stringify(detailPage.values.anchorGobos)} transform={{ _: "translateY(-6rem)", md: "translateY(-13.9rem)" }} />
      <Container flexDirection="column" py={{ _: "1.5rem", sm: "5rem" }}>
        <Box>
          <RobeProductDetailHeading
            onClick={() => setShowGobos(!showGobos)}
            active={showGobos}
            {...(showGobos && { mb: { _: "3rem", sm: "4rem" } })}
          >
            {"gobosColors" in detailPage.values && stringify(detailPage.values.gobosColors)}
          </RobeProductDetailHeading>

          <Collapse open={showGobos}>
            <SimpleGrid columns={{ _: 12 }} gap="3rem">
              <Cell gridColumn={{ _: "1/13", sm: "1/8" }}>
                <Stack direction="column" gap={{ _: "3rem", sm: "4rem" }}>
                  {product.values.wheels?.map((w, i) => {
                    if (!w?.wheels?.values || !w?.wheelSet?.values) {
                      return <Fragment key={i} />;
                    }

                    return (
                      <WheelSet
                        key={i}
                        wheelSetValues={w.wheelSet.values}
                        wheelsValues={w.wheels.map((wheel) => wheel.values as GoboValues)}
                        setActive={(ii) => setActive([i, ii])}
                        active={i === activeSet ? activeWheel : undefined}
                      />
                    );
                  })}
                </Stack>
              </Cell>

              {active && imgUrl && (
                <Cell column={{ sm: "9/13" }} display={{ _: "none", sm: "block" }}>
                  <Focus imageSrc={imgUrl} {...resolveSrcSet(imgUrl, retinaImgUrl)} onClick={() => openLightbox(0)} cursor="pointer" />
                </Cell>
              )}
            </SimpleGrid>
          </Collapse>
        </Box>
      </Container>
    </Box>
  );
};

export default ProductGobos;
